import React from 'react';

const variants = {
  disponivel: 'bg-green-100 text-green-800',
  reservada: 'bg-yellow-100 text-yellow-800',
  vendida: 'bg-red-100 text-red-800',
  distratada: 'bg-gray-100 text-gray-600',
  novo: 'bg-blue-100 text-blue-800',
  quente: 'bg-red-100 text-red-700',
  morno: 'bg-yellow-100 text-yellow-700',
  frio: 'bg-blue-100 text-blue-600',
  ativo: 'bg-green-100 text-green-700',
  parado: 'bg-gray-100 text-gray-600',
  meta_ads: 'bg-blue-100 text-blue-800',
  google_ads: 'bg-green-100 text-green-800',
  chaves_na_mao: 'bg-orange-100 text-orange-800',
  site: 'bg-purple-100 text-purple-800',
};

export default function Badge({ label, variant }) {
  const cls = variants[variant] || 'bg-gray-100 text-gray-700';
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {label}
    </span>
  );
}
